/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FeedbackItemResVo } from './FeedbackItemResVo';
import {
    FeedbackItemResVoFromJSON,
    FeedbackItemResVoFromJSONTyped,
    FeedbackItemResVoToJSON,
    FeedbackItemResVoToJSONTyped,
} from './FeedbackItemResVo';

/**
 * 
 * @export
 * @interface PageDataFeedbackItemResVo
 */
export interface PageDataFeedbackItemResVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataFeedbackItemResVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataFeedbackItemResVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataFeedbackItemResVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<FeedbackItemResVo>}
     * @memberof PageDataFeedbackItemResVo
     */
    records?: Array<FeedbackItemResVo>;
}

/**
 * Check if a given object implements the PageDataFeedbackItemResVo interface.
 */
export function instanceOfPageDataFeedbackItemResVo(value: object): value is PageDataFeedbackItemResVo {
    return true;
}

export function PageDataFeedbackItemResVoFromJSON(json: any): PageDataFeedbackItemResVo {
    return PageDataFeedbackItemResVoFromJSONTyped(json, false);
}

export function PageDataFeedbackItemResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataFeedbackItemResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(FeedbackItemResVoFromJSON)),
    };
}

export function PageDataFeedbackItemResVoToJSON(json: any): PageDataFeedbackItemResVo {
    return PageDataFeedbackItemResVoToJSONTyped(json, false);
}

export function PageDataFeedbackItemResVoToJSONTyped(value?: PageDataFeedbackItemResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(FeedbackItemResVoToJSON)),
    };
}

